import views from '@/views/';

export default [
  {
    component: views.global.messageList,
    label: '消息列表',
    path: 'messageList',
    name: 'messageList',
    id: 37,
  },
  {
    component: views.global.messageDetail,
    label: '消息详情',
    path: 'messageDetail',
    name: 'messageDetail',
    id: 37,
  },
  {
    component: views.global.help,
    label: '帮助中心',
    path: 'help',
    name: 'help',
    id: 37,
  },
  {
    component: views.global.registe,
    label: '申请注册',
    path: 'registe',
    name: 'registe',
    id: 37,
  },
  {
    component: views.global.forgetPwd,
    label: '忘记密码',
    path: 'forgetPwd',
    name: 'forgetPwd',
    id: 37,
  },
  {
    component: views.global.updatePwd,
    label: '修改密码',
    path: 'updatePwd',
    name: 'updatePwd',
    id: 37,
  },
];
